var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jira-modal" },
    [
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_report,
            expression: "modalState.jira_report",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_report", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_c("h3", [_vm._v("Send Report to Jira")])]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "section format-file-wrapper" },
                  [
                    _c("label", { staticClass: "label" }, [
                      _vm._v("Select file format to send"),
                    ]),
                    _vm._v(" "),
                    _c("multi-select", {
                      attrs: {
                        value: _vm.selectedReportTypes,
                        model: _vm.selectedReportTypes,
                        entries: _vm.reportTypes,
                        label: `Select report type`,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onConfigChanged(...arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Project")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedProject,
                          expression: "selectedProject",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProject = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.toggleSelectedProject,
                        ],
                      },
                    },
                    _vm._l(_vm.assignableJiraProject, function (project, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: project.key } },
                        [
                          _c("i", [_vm._v(_vm._s(project.key))]),
                          _vm._v(" - " + _vm._s(project.name)),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.issueTypes.length || _vm.epicList.length
                  ? _c(
                      "div",
                      { staticClass: "section select-option-wrapper" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Project Detail"),
                        ]),
                        _vm._v(" "),
                        _vm.issueTypes.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Issue Type"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedIssueType,
                                        expression: "selectedIssueType",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedIssueType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.issueTypes,
                                    function (issueType, key) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          domProps: { value: issueType },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(issueType.untranslatedName)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFieldsForm
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.allowIssueTypeFields,
                                function (field, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: idx,
                                      staticClass:
                                        "epic-list-wrapper section select-option-wrapper",
                                    },
                                    [
                                      field.key === "parent"
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(field.name) +
                                                  " Key\n                        "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v(_vm._s(field.name))]
                                          ),
                                      _vm._v(" "),
                                      field.required
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      field.type == "priority"
                                        ? _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.fieldValues[field.key],
                                                  expression:
                                                    "fieldValues[field.key]",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.fieldValues,
                                                    field.key,
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              field.allowedValues,
                                              function (prio, key) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: key,
                                                    domProps: {
                                                      value: prio.name,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(prio.name))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : field.type == "string"
                                        ? _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "date"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "datepicker-container",
                                            },
                                            [
                                              _c("a-date-picker", {
                                                ref: field.key,
                                                refInFor: true,
                                                attrs: {
                                                  format: _vm.dateFormat,
                                                  placeholder: "Select Date",
                                                  "disabled-date":
                                                    _vm.disabledDate,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleDateChange(
                                                      field.key,
                                                      ...arguments
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : field.type == "array"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Separated by comma",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "issuelink"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Input key",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "number"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                              placeholder: "Input number",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _vm.errors.includes(field.key)
                                        ? _c(
                                            "label",
                                            { staticClass: "label-error" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(field.name) +
                                                  " is required\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.epicList.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Epic"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEpicId,
                                        expression: "selectedEpicId",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedEpicId = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(_vm.epicList, function (epic, key) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        domProps: { value: epic.id },
                                      },
                                      [
                                        _c("i", [_vm._v(_vm._s(epic.key))]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              epic.raw.fields.customfield_10011
                                            )
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Assignee (Optional)"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAssignee,
                          expression: "selectedAssignee",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedAssignee = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      !_vm.selectedAssignee
                        ? _c("option", { attrs: { selected: "", value: "" } }, [
                            _vm._v("Select assignee"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.assignableJiraUser, function (user, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: user.account_id } },
                          [_vm._v(_vm._s(user.display_name))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm.isSubmitting
                  ? _c("span", [
                      _vm._v("Sending report to Jira ...   "),
                      _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        class: { "btn-disabled": !_vm.canSubmit },
                        on: {
                          click: function ($event) {
                            return _vm.sendReport()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-paper-plane" }),
                        _vm._v(
                          "\n                Send Report to Jira\n            "
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_host_issues,
            expression: "modalState.jira_host_issues",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_host_issues", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", [_vm._v("Send Host to Jira")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("jira_host_issues", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [_vm._v("Send host and its issues to Jira.")]),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Project")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedProject,
                          expression: "selectedProject",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProject = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.toggleSelectedProject,
                        ],
                      },
                    },
                    _vm._l(_vm.assignableJiraProject, function (project, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: project.key } },
                        [
                          _c("i", [_vm._v(_vm._s(project.key))]),
                          _vm._v(" - " + _vm._s(project.name)),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.issueTypes.length || _vm.epicList.length
                  ? _c(
                      "div",
                      { staticClass: "section select-option-wrapper" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Project Detail"),
                        ]),
                        _vm._v(" "),
                        _vm.issueTypes.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Issue Type"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedIssueType,
                                        expression: "selectedIssueType",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedIssueType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.issueTypes,
                                    function (issueType, key) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          domProps: { value: issueType },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(issueType.untranslatedName)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFieldsForm
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.allowIssueTypeFields,
                                function (field, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: idx,
                                      staticClass:
                                        "epic-list-wrapper section select-option-wrapper",
                                    },
                                    [
                                      field.key === "parent"
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(field.name) +
                                                  " Key\n                        "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v(_vm._s(field.name))]
                                          ),
                                      _vm._v(" "),
                                      field.required
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      field.type == "priority"
                                        ? _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.fieldValues[field.key],
                                                  expression:
                                                    "fieldValues[field.key]",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.fieldValues,
                                                    field.key,
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              field.allowedValues,
                                              function (prio, key) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: key,
                                                    domProps: {
                                                      value: prio.name,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(prio.name))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : field.type == "string"
                                        ? _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "date"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "datepicker-container",
                                            },
                                            [
                                              _c("a-date-picker", {
                                                ref: field.key,
                                                refInFor: true,
                                                attrs: {
                                                  format: _vm.dateFormat,
                                                  placeholder: "Select Date",
                                                  "disabled-date":
                                                    _vm.disabledDate,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleDateChange(
                                                      field.key,
                                                      ...arguments
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : field.type == "array"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Separated by comma",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "issuelink"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Input key",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "number"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                              placeholder: "Input number",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _vm.errors.includes(field.key)
                                        ? _c(
                                            "label",
                                            { staticClass: "label-error" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(field.name) +
                                                  " is required\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.epicList.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Epic"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEpicId,
                                        expression: "selectedEpicId",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedEpicId = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(_vm.epicList, function (epic, key) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        domProps: { value: epic.id },
                                      },
                                      [
                                        _c("i", [_vm._v(_vm._s(epic.key))]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              epic.raw.fields.customfield_10011
                                            )
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Assignee (Optional)"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAssignee,
                          expression: "selectedAssignee",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedAssignee = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      !_vm.selectedAssignee
                        ? _c("option", { attrs: { selected: "", value: "" } }, [
                            _vm._v("Select assignee"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.assignableJiraUser, function (user, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: user.account_id } },
                          [_vm._v(_vm._s(user.display_name))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm.isSubmitting
                  ? _c("span", [
                      _vm._v("Sending host and its issues to Jira ...   "),
                      _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        class: { "btn-disabled": !_vm.canSubmit },
                        on: {
                          click: function ($event) {
                            return _vm.sendHost()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-paper-plane" }),
                        _vm._v(
                          "\n                Send Host to Jira\n            "
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_issue_hosts,
            expression: "modalState.jira_issue_hosts",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_issue_hosts", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", [_vm._v("Send Issue to Jira")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("jira_issue_hosts", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [_vm._v("Send issue and its affected hosts to Jira.")]),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Project")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedProject,
                          expression: "selectedProject",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProject = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.toggleSelectedProject,
                        ],
                      },
                    },
                    _vm._l(_vm.assignableJiraProject, function (project, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: project.key } },
                        [
                          _c("i", [_vm._v(_vm._s(project.key))]),
                          _vm._v(" - " + _vm._s(project.name)),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.issueTypes.length || _vm.epicList.length
                  ? _c(
                      "div",
                      { staticClass: "section select-option-wrapper" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Project Detail"),
                        ]),
                        _vm._v(" "),
                        _vm.issueTypes.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Issue Type"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedIssueType,
                                        expression: "selectedIssueType",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedIssueType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.issueTypes,
                                    function (issueType, key) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          domProps: { value: issueType },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(issueType.untranslatedName)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFieldsForm
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.allowIssueTypeFields,
                                function (field, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: idx,
                                      staticClass:
                                        "epic-list-wrapper section select-option-wrapper",
                                    },
                                    [
                                      field.key === "parent"
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(field.name) +
                                                  " Key\n                        "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v(_vm._s(field.name))]
                                          ),
                                      _vm._v(" "),
                                      field.required
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      field.type == "priority"
                                        ? _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.fieldValues[field.key],
                                                  expression:
                                                    "fieldValues[field.key]",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.fieldValues,
                                                    field.key,
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              field.allowedValues,
                                              function (prio, key) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: key,
                                                    domProps: {
                                                      value: prio.name,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(prio.name))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : field.type == "string"
                                        ? _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "date"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "datepicker-container",
                                            },
                                            [
                                              _c("a-date-picker", {
                                                ref: field.key,
                                                refInFor: true,
                                                attrs: {
                                                  format: _vm.dateFormat,
                                                  placeholder: "Select Date",
                                                  "disabled-date":
                                                    _vm.disabledDate,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleDateChange(
                                                      field.key,
                                                      ...arguments
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : field.type == "array"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Separated by comma",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "issuelink"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Input key",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "number"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                              placeholder: "Input number",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _vm.errors.includes(field.key)
                                        ? _c(
                                            "label",
                                            { staticClass: "label-error" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(field.name) +
                                                  " is required\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.epicList.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Epic"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEpicId,
                                        expression: "selectedEpicId",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedEpicId = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(_vm.epicList, function (epic, key) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        domProps: { value: epic.id },
                                      },
                                      [
                                        _c("i", [_vm._v(_vm._s(epic.key))]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              epic.raw.fields.customfield_10011
                                            )
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Assignee (Optional)"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAssignee,
                          expression: "selectedAssignee",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedAssignee = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      !_vm.selectedAssignee
                        ? _c("option", { attrs: { selected: "", value: "" } }, [
                            _vm._v("Select assignee"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.assignableJiraUser, function (user, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: user.account_id } },
                          [_vm._v(_vm._s(user.display_name))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm.isSubmitting
                  ? _c("span", [
                      _vm._v(
                        "Sending issue and its affected hosts to Jira ...   "
                      ),
                      _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        class: { "btn-disabled": !_vm.canSubmit },
                        on: {
                          click: function ($event) {
                            return _vm.sendIssue()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-paper-plane" }),
                        _vm._v(
                          "\n                Send Issue to Jira\n            "
                        ),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_cyber_fitness,
            expression: "modalState.jira_cyber_fitness",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_cyber_fitness", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_c("h3", [_vm._v("Send Cyber Fitness to Jira")])]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Project")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedProject,
                          expression: "selectedProject",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProject = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.toggleSelectedProject,
                        ],
                      },
                    },
                    _vm._l(_vm.assignableJiraProject, function (project, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: project.key } },
                        [
                          _c("i", [_vm._v(_vm._s(project.key))]),
                          _vm._v(" - " + _vm._s(project.name)),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.issueTypes.length || _vm.epicList.length
                  ? _c(
                      "div",
                      { staticClass: "section select-option-wrapper" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Project Detail"),
                        ]),
                        _vm._v(" "),
                        _vm.issueTypes.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Issue Type"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedIssueType,
                                        expression: "selectedIssueType",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedIssueType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.issueTypes,
                                    function (issueType, key) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          domProps: { value: issueType },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(issueType.untranslatedName)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFieldsForm
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.allowIssueTypeFields,
                                function (field, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: idx,
                                      staticClass:
                                        "epic-list-wrapper section select-option-wrapper",
                                    },
                                    [
                                      field.key === "parent"
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(field.name) +
                                                  " Key\n                        "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v(_vm._s(field.name))]
                                          ),
                                      _vm._v(" "),
                                      field.required
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      field.type == "priority"
                                        ? _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.fieldValues[field.key],
                                                  expression:
                                                    "fieldValues[field.key]",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.fieldValues,
                                                    field.key,
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              field.allowedValues,
                                              function (prio, key) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: key,
                                                    domProps: {
                                                      value: prio.name,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(prio.name))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : field.type == "string"
                                        ? _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "date"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "datepicker-container",
                                            },
                                            [
                                              _c("a-date-picker", {
                                                ref: field.key,
                                                refInFor: true,
                                                attrs: {
                                                  format: _vm.dateFormat,
                                                  placeholder: "Select Date",
                                                  "disabled-date":
                                                    _vm.disabledDate,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleDateChange(
                                                      field.key,
                                                      ...arguments
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : field.type == "array"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Separated by comma",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "issuelink"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Input key",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "number"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                              placeholder: "Input number",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _vm.errors.includes(field.key)
                                        ? _c(
                                            "label",
                                            { staticClass: "label-error" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(field.name) +
                                                  " is required\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.epicList.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Epic"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEpicId,
                                        expression: "selectedEpicId",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedEpicId = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(_vm.epicList, function (epic, key) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        domProps: { value: epic.id },
                                      },
                                      [
                                        _c("i", [_vm._v(_vm._s(epic.key))]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              epic.raw.fields.customfield_10011
                                            )
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Assignee (Optional)"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAssignee,
                          expression: "selectedAssignee",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedAssignee = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      !_vm.selectedAssignee
                        ? _c("option", { attrs: { selected: "", value: "" } }, [
                            _vm._v("Select assignee"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.assignableJiraUser, function (user, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: user.account_id } },
                          [_vm._v(_vm._s(user.display_name))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm.isSubmitting
                  ? _c("span", [
                      _vm._v("Sending report to Jira ...   "),
                      _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function ($event) {
                            return _vm.sendCyberFitnessToJira()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-paper-plane" }),
                        _vm._v("\n                Send to Jira\n            "),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_multiple_cyber_fitness,
            expression: "modalState.jira_multiple_cyber_fitness",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_multiple_cyber_fitness", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [_c("h3", [_vm._v("Send Multiple Cyber Fitness to Jira")])]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [_vm._v("Project")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedProject,
                          expression: "selectedProject",
                        },
                      ],
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedProject = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.toggleSelectedProject,
                        ],
                      },
                    },
                    _vm._l(_vm.assignableJiraProject, function (project, key) {
                      return _c(
                        "option",
                        { key: key, domProps: { value: project.key } },
                        [
                          _c("i", [_vm._v(_vm._s(project.key))]),
                          _vm._v(" - " + _vm._s(project.name)),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _vm.issueTypes.length || _vm.epicList.length
                  ? _c(
                      "div",
                      { staticClass: "section select-option-wrapper" },
                      [
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Project Detail"),
                        ]),
                        _vm._v(" "),
                        _vm.issueTypes.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Issue Type"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedIssueType,
                                        expression: "selectedIssueType",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedIssueType = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(
                                    _vm.issueTypes,
                                    function (issueType, key) {
                                      return _c(
                                        "option",
                                        {
                                          key: key,
                                          domProps: { value: issueType },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(issueType.untranslatedName)
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showFieldsForm
                          ? _c(
                              "div",
                              _vm._l(
                                _vm.allowIssueTypeFields,
                                function (field, idx) {
                                  return _c(
                                    "div",
                                    {
                                      key: idx,
                                      staticClass:
                                        "epic-list-wrapper section select-option-wrapper",
                                    },
                                    [
                                      field.key === "parent"
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(field.name) +
                                                  " Key\n                        "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v(_vm._s(field.name))]
                                          ),
                                      _vm._v(" "),
                                      field.required
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "label",
                                              class: {
                                                "label-error":
                                                  _vm.errors.includes(
                                                    field.key
                                                  ),
                                              },
                                            },
                                            [_vm._v("*")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      field.type == "priority"
                                        ? _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.fieldValues[field.key],
                                                  expression:
                                                    "fieldValues[field.key]",
                                                },
                                              ],
                                              on: {
                                                change: function ($event) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.$set(
                                                    _vm.fieldValues,
                                                    field.key,
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  )
                                                },
                                              },
                                            },
                                            _vm._l(
                                              field.allowedValues,
                                              function (prio, key) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: key,
                                                    domProps: {
                                                      value: prio.name,
                                                    },
                                                  },
                                                  [_vm._v(_vm._s(prio.name))]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : field.type == "string"
                                        ? _c("textarea", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "date"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "datepicker-container",
                                            },
                                            [
                                              _c("a-date-picker", {
                                                ref: field.key,
                                                refInFor: true,
                                                attrs: {
                                                  format: _vm.dateFormat,
                                                  placeholder: "Select Date",
                                                  "disabled-date":
                                                    _vm.disabledDate,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.handleDateChange(
                                                      field.key,
                                                      ...arguments
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : field.type == "array"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Separated by comma",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "issuelink"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              placeholder: "Input key",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : field.type == "number"
                                        ? _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: {
                                              type: "number",
                                              placeholder: "Input number",
                                            },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          })
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.fieldValues[field.key],
                                                expression:
                                                  "fieldValues[field.key]",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            domProps: {
                                              value: _vm.fieldValues[field.key],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.fieldValues,
                                                  field.key,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                      _vm._v(" "),
                                      _vm.errors.includes(field.key)
                                        ? _c(
                                            "label",
                                            { staticClass: "label-error" },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(field.name) +
                                                  " is required\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.epicList.length
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "epic-list-wrapper section select-option-wrapper",
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Epic"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selectedEpicId,
                                        expression: "selectedEpicId",
                                      },
                                    ],
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.selectedEpicId = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  _vm._l(_vm.epicList, function (epic, key) {
                                    return _c(
                                      "option",
                                      {
                                        key: key,
                                        domProps: { value: epic.id },
                                      },
                                      [
                                        _c("i", [_vm._v(_vm._s(epic.key))]),
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              epic.raw.fields.customfield_10011
                                            )
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "section select-option-wrapper" }, [
                  _c("label", { staticClass: "label" }, [
                    _vm._v("Assignee (Optional)"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedAssignee,
                          expression: "selectedAssignee",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectedAssignee = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      !_vm.selectedAssignee
                        ? _c("option", { attrs: { selected: "", value: "" } }, [
                            _vm._v("Select assignee"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.assignableJiraUser, function (user, key) {
                        return _c(
                          "option",
                          { key: key, domProps: { value: user.account_id } },
                          [_vm._v(_vm._s(user.display_name))]
                        )
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _vm.isSubmitting
                  ? _c("span", [
                      _vm._v("Sending report to Jira ...   "),
                      _c("i", { staticClass: "fa fa-spinner fa-pulse" }),
                    ])
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        on: {
                          click: function ($event) {
                            return _vm.sendMultipleCyberFitnessToJira()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-paper-plane" }),
                        _vm._v("\n                Send to Jira\n            "),
                      ]
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_return_success,
            expression: "modalState.jira_return_success",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_return_success", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", [_vm._v("Successfully send to Jira")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("jira_return_success", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [_vm._v("Jira ticket detail:")]),
                _vm._v(" "),
                _c("div", { staticClass: "jira-issue-detail" }, [
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "key" }, [_vm._v("Issue ID")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.successResponse.issue_id)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "key" }, [_vm._v("Issue Key")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.successResponse.issue_key)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section" }, [
                    _c("div", { staticClass: "key" }, [_vm._v("Issue Link")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "value" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.successResponse.issue_link,
                            target: "_blank",
                          },
                        },
                        [_vm._v(_vm._s(_vm.successResponse.issue_link))]
                      ),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_return_fail,
            expression: "modalState.jira_return_fail",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_return_fail", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h3", [_vm._v("Oops, request failed.")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal("jira_return_fail", false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("p", [
                  _vm._v(
                    "There is a problem with your request. We are currently not able to send the issue to Jira."
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.modalState.jira_return_success_multiple,
            expression: "modalState.jira_return_success_multiple",
          },
        ],
        attrs: { container: "modal-container" },
        on: {
          close: function ($event) {
            return _vm.updateModal("jira_return_success_multiple", false)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _vm.failResponseMultiple.length > 0 &&
                _vm.successResponseMultiple.length === 0
                  ? _c("h3", [_vm._v("Oops, request failed.")])
                  : _vm.failResponseMultiple.length > 0
                  ? _c("h3", [
                      _vm._v("Oops, not all issues are successfully sent."),
                    ])
                  : _c("h3", [_vm._v("Successfully send to Jira")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: { type: "button", "aria-label": "Close Modal" },
                    on: {
                      click: function ($event) {
                        return _vm.updateModal(
                          "jira_return_success_multiple",
                          false
                        )
                      },
                    },
                  },
                  [_c("i", { staticClass: "fas fa-times close-modal" })]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _vm.failResponseMultiple.length > 0 &&
                _vm.successResponseMultiple.length === 0
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "There is a problem with your request. We are currently not able to send the issue to Jira. "
                        ),
                      ]),
                    ])
                  : _vm.successResponseMultiple.length > 0
                  ? _c("div", { staticClass: "jira-issue-detail" }, [
                      _vm.failResponseMultiple.length > 0
                        ? _c("p", [
                            _vm._v("Here are the successful ticket detail:"),
                          ])
                        : _c("p", [_vm._v("Jira ticket detail:")]),
                      _vm._v(" "),
                      _c("table", { staticClass: "multiple-responses" }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Issue ID")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Issue Link")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.successResponseMultiple, function (item) {
                            return _c("tr", { key: item.issue_id }, [
                              _c("td", [_vm._v(_vm._s(item.issue_id))]),
                              _vm._v(" "),
                              _c("td", [
                                _c("a", { attrs: { href: item.issue_link } }, [
                                  _vm._v(_vm._s(item.issue_link)),
                                ]),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.failResponseMultiple.length > 0
                  ? _c("div", { staticClass: "failed-list" }, [
                      _c("p", [
                        _vm._v(
                          "Unfortunately, there " +
                            _vm._s(
                              _vm.failResponseMultiple.length > 1 ? "are" : "is"
                            ) +
                            " " +
                            _vm._s(_vm.failResponseMultiple.length) +
                            " more " +
                            _vm._s(
                              _vm.failResponseMultiple.length > 1
                                ? "tickets"
                                : "ticket"
                            ) +
                            "  that " +
                            _vm._s(
                              _vm.failResponseMultiple.length > 1 ? "are" : "is"
                            ) +
                            " unsuccessful to send. "
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }